import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=f79d143c&scoped=true&"
import script from "./InputPhone.vue?vue&type=script&lang=ts&"
export * from "./InputPhone.vue?vue&type=script&lang=ts&"
import style0 from "./InputPhone.vue?vue&type=style&index=0&id=f79d143c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79d143c",
  null
  
)

export default component.exports